/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChannelsFollowedIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA+UlEQVR4nO2UWwrCMBBF3YSiO6qPSSYfZQZ0Z+JWLLS4ARX0W92HktZgjEltaz5EHCiUPO7JhJvb6/1MCcVTgXwRyFf3A0nnGdLYrAVJK0DOlFoMbA1A3ghJhRegRXziwkCQT5ZQVo5L3tkQs9bfQY24cDYmadoHpG0FoYNS81FUQAgSFWAg+pqqedpHB7x0EgsA2i0tD9LKRUJSUbMu9wK0z7VISBwUJ96N/4pate6Qj4xpk1tP9cZFeRfHBQGAfDQZ0+YgzR6b9fyVE8lRAKG0jAbQ/y5kkqbDqAADEffrAuT15wBJhZslSdkJZ4C0NGOdXdS0viq3bkH865iYXJNpAAAAAElFTkSuQmCC)
 */
export const ChannelsFollowedIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M14 10a1 1 0 1 1 0-2h3.59l-4.3-4.3a1 1 0 0 1 1.42-1.4L19 6.58V3a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1h-6ZM4 2a2 2 0 0 0-2 2v5c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4ZM15 14a2 2 0 0 0-2 2v5c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-5ZM11 15a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0v-3.59l4.3 4.3a1 1 0 0 0 1.4-1.42L6.42 16H10a1 1 0 0 0 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
